/* eslint-disable react-refresh/only-export-components */
import { Navigate } from 'react-router';
import { lazy } from 'react';
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
const ListPayments = lazy(
  () => import('@/modules/accounting/payments/list/ListPayments'),
);

const PaymentApprovals = lazy(
  () =>
    import('@/modules/accounting/payments/payment-approvals/PaymentApprovalsList'),
);

const AddRecord = lazy(
  () => import('@/modules/accounting/payments/add/AddPayment'),
);

const ViewPayment = lazy(
  () => import('@/modules/accounting/payments/view/ViewPayment'),
);

const ListCredits = lazy(
  () => import('@/modules/accounting/credit-note/list/ListCredits'),
);

const ViewCredit = lazy(
  () => import('@/modules/accounting/credit-note/view/ViewCredit'),
);

const AddCreditNote = lazy(
  () => import('@/modules/accounting/credit-note/add/AddCreditNote'),
);
const ViewInvoiceData = lazy(
  () => import('@/modules/accounting/invoices/view/ViewInvoiceData'),
);
const ListCustomerInvoices = lazy(
  () => import('@/modules/accounting/invoices/list/ListCustomerInvoices'),
);
const CustomerInvoices = lazy(
  () => import('@/modules/accounting/invoices/add/CustomerInvoices'),
);
const PrivateViewInvoice = lazy(
  () =>
    import('@/modules/export/shipping/invoices/components/components/preview-invoice/PrivateViewInvoice'),
);

export const accountingRoutes = [
  {
    path: 'invoice',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: withSuspense(ListCustomerInvoices),
      },
      {
        path: 'add',
        element: withSuspense(CustomerInvoices),
        children: [
          {
            path: ':shippingId/shipping/:proformaId/proforma/:invoiceId/ship',
            element: withSuspense(CustomerInvoices),
          },
          {
            path: ':shippingId/shipping/:invoiceId/ship',
            element: withSuspense(CustomerInvoices),
          },
        ],
      },
      {
        path: ':id/view',
        element: withSuspense(ViewInvoiceData),
      },
      {
        path: 'invoice',
        children: [
          {
            path: 'view',
            element: withSuspense(PrivateViewInvoice),
          },
        ],
      },
    ],
  },
  {
    path: 'payments',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: withSuspense(ListPayments),
      },
      {
        path: 'add',
        element: withSuspense(AddRecord),
      },
      {
        path: 'approve',
        element: withSuspense(PaymentApprovals),
      },
      {
        path: ':id/view',
        element: withSuspense(ViewPayment),
      },
    ],
  },
  {
    path: 'credits',
    children: [
      {
        index: true,
        element: <Navigate to="list" replace />,
      },
      {
        path: 'list',
        element: withSuspense(ListCredits),
      },
      {
        path: 'add',
        element: withSuspense(AddCreditNote),
      },
      {
        path: ':id/view',
        element: withSuspense(ViewCredit),
      },
    ],
  },
];
